import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";

import './index.scss';

import { Pagination } from "@mui/material";
import { useFetching } from '../../hooks/useFetching';
import MarketplaceResource from '../../helpers/marketplaceResource';
import { getPageCount } from '../../utils/pages';

const { REACT_APP_IMAGE_URL } = process.env;

const MarketPlace = () => {
    let history = useHistory();
    const [template, setTemplate] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [limit, setLimit] = useState(9);
    const [page, setPage] = useState(0);

    const [fetchTemplate, isTemplateLoading, templateError] = useFetching(async (page, limit) => {
      const response = MarketplaceResource.getAll('/marketplaces', page, limit);
      response.then(res => {
        const totalCount = res.data.count;
        setTemplate(res.data.data);
        setTotalPages(getPageCount(totalCount, limit));
      });
    });

    useEffect(async () => {
      fetchTemplate(page, limit).then();
    }, [])

    const navigate = (e, id) => {
      e.preventDefault();
      history.push(`/marketplace/${id}`);
    }

    const handleChange = (event, value) => {
      event.preventDefault();
      fetchTemplate(value - 1, limit).then();
    };

  return (
      <div className="marketplace-wrapper">
          <div className="page-title-block ">
              <div className="container-layout">
                  <div className="page-title-inner">
                      <h1 className="page-title">Marketplace</h1>
                      <p className="page-title-txt">Offer your customers a complete and unique user experience with our ready-to-operate platforms.</p>
                  </div>
              </div>
          </div>
          <div className="container-layout">
              <div className="marketplace-content-wrp">
                  <div className="marketplace-content-holder">
                      {
                          template && template.map((item, idx) => {
                              return <div key={idx} className="marketplace-content-item">
                                          <div className="marketplace-item-img">
                                              <img
                                                src={`${REACT_APP_IMAGE_URL}` + item.file.path}
                                                alt={item.title}/>
                                          </div>
                                          <div className="marketplace-item-info">
                                              <p className="marketplace-item-info-title">{item.title}</p>
                                              <p className="marketplace-item-info-text">{item.shortDescription}</p>
                                              <div className="marketplace-item-info-btn-inner">
                                                  <div className="btn-wrapper">
                                                      <button className="stroked " type="button" onClick={() => window.open(item.previewLink, '_blank')}>Preview</button>
                                                  </div>
                                                  <div className="btn-wrapper">
                                                      <button className="filled " type="button" onClick={(e) => navigate(e, item.id)}>Learn More</button>
                                                  </div>
                                              </div>
                                          </div>
                                        </div>
                          })
                      }
                  </div>

                { (template?.length > 0) ?
                  <div className="pagination-wrapper">
                    <Pagination count={totalPages} defaultPage={1} siblingCount={2} boundaryCount={0} onChange={handleChange} shape="rounded"/>
                  </div> : null
                }

              </div>
          </div>
      </div>
  );
};

export default MarketPlace;
